<template>
  <b-card no-body class="h-100">
    <b-card-header>
      <b-card-title>Оценки игроков · 4 недели</b-card-title>
      <small v-if="counts.games_with_review_share !== null" class="text-muted">
        отзыв есть у {{ formatPercent(counts.games_with_review_share) }} игр ({{ counts.games_with_review }}/{{ counts.games_total }})
      </small>
    </b-card-header>
    <b-card-body class="pt-0">
      <b-row class="mb-1">
        <b-col v-for="tile in tiles" :key="tile.title" cols="6" md="3" class="text-center">
          <h4 class="mb-0" :class="ratingClass(tile.value)">{{ tile.value != null ? tile.value.toFixed(2) : '—' }}</h4>
          <small class="text-muted">{{ tile.title }}</small>
        </b-col>
      </b-row>

      <vue-apex-charts v-if="trend.length" type="line" height="180" :options="chartOptions" :series="series" />

      <b-row class="mt-1">
        <b-col md="6">
          <small class="text-uppercase text-muted font-weight-bold">Пожелания по сложности</small>
          <div class="d-flex flex-wrap mt-25">
            <b-badge variant="light-danger" class="mr-50 mb-25">сложнее: {{ wishes.harder }}</b-badge>
            <b-badge variant="light-success" class="mr-50 mb-25">норм: {{ wishes.ok }}</b-badge>
            <b-badge variant="light-warning" class="mr-50 mb-25">легче: {{ wishes.easier }}</b-badge>
            <b-badge v-if="wishes.other" variant="light-secondary" class="mb-25">другое: {{ wishes.other }}</b-badge>
          </div>
        </b-col>
        <b-col md="6">
          <small class="text-uppercase text-muted font-weight-bold">Лучший / худший за месяц</small>
          <div v-for="item in extremes" :key="item.label" class="font-small-3">
            <span class="text-muted">{{ item.label }}:</span>
            <template v-if="item.value">
              {{ item.value.name }}
              <b-badge :variant="`light-${item.variant}`">{{ item.value.average_rating.toFixed(2) }} · {{ item.value.ratings_count }}</b-badge>
            </template>
            <span v-else class="text-muted">— (мало оценок)</span>
          </div>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BRow, BCol, BBadge,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { computed } from '@vue/composition-api'
import { $themeColors } from '@themeConfig'
import { formatPercent } from '@/views/finance/utils'
import { formatDate } from '@/views/dashboard/sifnf/utils'

export default {
  components: {
    BCard, BCardHeader, BCardTitle, BCardBody, BRow, BCol, BBadge, VueApexCharts,
  },
  props: {
    feedback: { type: Object, default: null },
  },
  setup(props) {
    const averages = computed(() => (props.feedback && props.feedback.averages) || {})
    const trend = computed(() => [...((props.feedback && props.feedback.trend) || [])].sort((a, b) => String(a.week_friday).localeCompare(String(b.week_friday))))
    const counts = computed(() => (props.feedback && props.feedback.counts) || { games_with_review_share: null })
    const wishes = computed(() => (props.feedback && props.feedback.difficulty_wishes) || { harder: 0, easier: 0, ok: 0, other: 0 })
    const bestWorst = computed(() => (props.feedback && props.feedback.best_worst) || {})

    const tiles = computed(() => [
      { title: 'Игра', value: averages.value.game },
      { title: 'Ведущий', value: averages.value.host },
      { title: 'Пакет', value: averages.value.pack },
      { title: 'Сложность', value: averages.value.difficulty },
    ])

    const ratingClass = value => {
      if (value == null) return 'text-muted'
      if (value >= 4.5) return 'text-success'
      return value >= 4 ? 'text-warning' : 'text-danger'
    }

    const extremes = computed(() => [
      { label: 'Лучший пакет', value: bestWorst.value.best_pack, variant: 'success' },
      { label: 'Худший пакет', value: bestWorst.value.worst_pack, variant: 'danger' },
      { label: 'Лучший ведущий', value: bestWorst.value.best_host, variant: 'success' },
      { label: 'Худший ведущий', value: bestWorst.value.worst_host, variant: 'danger' },
    ])

    const series = computed(() => [
      { name: 'Игра', data: trend.value.map(t => t.game) },
      { name: 'Ведущий', data: trend.value.map(t => t.host) },
      { name: 'Пакет', data: trend.value.map(t => t.pack) },
    ])

    const chartOptions = computed(() => ({
      chart: { toolbar: { show: false }, sparkline: { enabled: false } },
      colors: [$themeColors.primary, $themeColors.info, $themeColors.warning],
      stroke: { curve: 'smooth', width: 2 },
      markers: { size: 3 },
      xaxis: { categories: trend.value.map(t => formatDate(t.week_friday)), labels: { style: { fontSize: '10px' } } },
      yaxis: { min: 1, max: 5, tickAmount: 4, labels: { formatter: val => val.toFixed(1) } },
      tooltip: { shared: true, intersect: false },
      legend: { position: 'top', fontSize: '11px' },
    }))

    return {
      averages, trend, counts, wishes, tiles, extremes, ratingClass, series, chartOptions, formatPercent,
    }
  },
}
</script>
